import { render, staticRenderFns } from "./AstroChart.vue?vue&type=template&id=570542fd"
import script from "./AstroChart.vue?vue&type=script&lang=js"
export * from "./AstroChart.vue?vue&type=script&lang=js"
import style0 from "./AstroChart.vue?vue&type=style&index=0&id=570542fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports